import app from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyD4iFcFgJ6FzfGg1XWUFEuIf_pHgeOqReA",
  authDomain: "koole-io.firebaseapp.com",
  databaseURL: "https://koole-io.firebaseio.com",
  projectId: "koole-io",
  storageBucket: "koole-io.appspot.com",
  messagingSenderId: "148611522242"
};

class Firebase {
  auth: any;
  db: any;
  appleProvider: any;
  googleProvider: any;
  facebookProvider: any;

  constructor() {
    app.initializeApp(config);
    this.appleProvider = new app.auth.OAuthProvider("apple.com");
    this.googleProvider = new app.auth.GoogleAuthProvider();
    this.facebookProvider = new app.auth.FacebookAuthProvider();

    this.auth = app.auth();
    this.db = app.firestore();
  }

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithApple = () =>
    this.auth.signInWithPopup(this.appleProvider);

  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);
}

export default Firebase;
